import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ButtonProps as MuiButtonProps } from '@mui/material';
import { StyledButton } from './Button.styled';

type Variant = 'primary' | 'secondary' | 'tertiary';

interface ButtonProps extends MuiButtonProps {
  children: React.ReactNode;
  variant?: Variant;
}

const whiteTheme = createTheme({
  palette: {
    primary: {
      main: '#FFFFFF',
    },
    secondary: {
      main: '#265183',
    },
  },
});

const ButtonVariants = {
  primary: 'contained',
  secondary: 'outlined',
  tertiary: 'text',
};

const Button = ({ children, variant = 'primary', ...params }: ButtonProps) => {
  return (
    <ThemeProvider theme={whiteTheme}>
      <StyledButton disableRipple variant={ButtonVariants[variant] as Variant} color='secondary' {...params}>
        {children}
      </StyledButton>
    </ThemeProvider>
  );
};

export default Button;
